<template>
    <el-row class="main-box flex-cloumn flex1">
        <el-col>
            <el-row>
                <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 22, offset: 1 }"
                    :lg="{ span: 22, offset: 1 }">
                    <div class="content-box2 flex-cloumn ">
                        <div class="content-box2-tips flex-row f-align-center">
                            <span>优秀学员申请</span>
                        </div>
                        <div class="content-box-bottom">
                            <el-image class="content-box-bottom-bg"
                                :src="require('@/static/vocabulary-text-contetn-bg.png')" fit="fill"
                                :lazy="true"></el-image>


                            <el-form :hide-required-asterisk="true" :model="ruleForm" :rules="rules" ref="ruleForm"
                                label-width="140px" class="content-box-form">
                                <el-form-item label="选择学员" prop="studentId">
                                    <el-select @change="studentChange" class="content-box-select"
                                        v-model="ruleForm.studentId" placeholder="请选择学员">
                                        <el-option v-for="item in studentList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="选择月份" prop="month">
                                    <el-select class="content-box-select" v-model="ruleForm.month" placeholder="请选择月份">
                                        <el-option v-for="item in monthList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="选择课程" prop="class">
                                    <el-select class="content-box-select" v-model="ruleForm.class" placeholder="请选择课程">
                                        <el-option v-for="item in classList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="申请优秀  学员的理由" prop="desc">
                                    <el-input v-model="ruleForm.desc" type="textarea" :row="7"
                                        :autosize="{ minRows: 6, maxRows: 7 }" maxlength="200"
                                        placeholder="请输入理由"></el-input>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0;">
                                    <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                                    <el-button @click="resetForm('ruleForm')">返回</el-button> -->
                                    <div class="start-popup-content-btnsbox flex-row ">
                                        <div style="cursor: pointer;" @click="backHandle">返回</div>
                                        <div style="cursor: pointer;" @click="submitForm('ruleForm')">提交</div>
                                    </div>
                                </el-form-item>
                            </el-form>

                            <el-image class="content-box-bottom-badge"
                                src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image5.jpg"
                                fit="cover" :lazy="true"></el-image>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-col>
    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from "moment";
import { Message } from 'element-ui';
import lodash from "lodash";

export default {
    data() {
        return {
            dialogStartClass: false,
            dialogStartClass2: false,
            dialogConfrimStartClass: false,
            studentList: [],
            monthList: [],
            classList: [],
            ruleForm: {
                studentId: "",
                month: "",
                class: "",
                desc: ""
            },
            rules: {
                studentId: [
                    { required: true, message: '请选择学院', trigger: 'change' },
                ],
                month: [
                    { required: true, message: '请选择月份', trigger: 'change' },
                ],
                class: [
                    { required: true, message: '请选择课程', trigger: 'change' },
                ],
                desc: [
                    { required: true, message: '请输入理由', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        this.initPage();
    },
    computed: {
        ...mapState([
            'userToken',
            'userInfos',
        ]),
        ...mapGetters(["getUserToken"])
    },
    methods: {
        backHandle() {
            this.$router.back();
        },
        initPage() {
            this.getMonthBetween();
            this.getStudentList();
            // this.getdataCourseList();
        },

        submitForm: lodash.debounce(function (formName) {

            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let res = await this.$api.post("web/teacher/home/outstandStudentApply",
                        {
                            applyMonth: this.ruleForm.month,
                            applyReason: this.ruleForm.desc,
                            courseId: this.ruleForm.class,
                            studentId: this.ruleForm.studentId,
                        }, {
                        headers: { //头部参数
                            frontUserToken: this.getUserToken
                        }
                    })
                    if (res.code == 200) {
                        Message({
                            type: "success",
                            message: "申请成功"
                        })
                        let t = setTimeout(() => {
                            clearTimeout(t);
                            this.$router.back();
                        }, 200);
                    } else {
                        Message({
                            type: "error",
                            message: res.msg
                        })
                    }

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
            500,
            {
                leading: false,
                trailing: true,
            }
        ),


        getMonthBetween() {
            const startDate = moment(new Date(), "YYYY-MM-DD").subtract(1,"month");
            const endDate = moment(new Date(), "YYYY-MM-DD").add(2, "year");
            // console.log( startDate.add(1, 'month'),endDate.format('M') )

            while (endDate > startDate || startDate.format('M') === endDate.format('M')) {
                this.monthList.push({
                    value: startDate.format('YYYY-MM'),
                    label: startDate.format('YYYY-MM')
                })
                startDate.add(1, 'month');
            }

        },
        async getdataCourseList() {
            this.classList = [];
            if (this.userInfos.role == "1") {
                let res = await this.$api.get("/web/teacher/attendClass/sudokuStudentCourseList", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        studentId: this.ruleForm.studentId,
                    }
                });
                if (res.code == 200) {

                    if (res.data) {
                        res.data.map(item => {
                            this.classList.push({
                                value: item.id,
                                label: item.name
                            });
                        })
                    }
                }
            }

        },
        async getStudentList() { //教师获取学生列表
            this.studentList = [];
            if (this.userInfos.role == "1") {

                let res = null;
                let apiUrl = "web/teacher/home/studentList";
                let params = {};
                res = await this.$api.get(apiUrl, {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params
                })

                if (res.code == 200) {

                    if (res.data) {
                        res.data.map(item => {
                            this.studentList.push({
                                value: item.id,
                                label: item.userName
                            });
                        })
                    }
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }
            }
        },
        studentChange() {
            this.getdataCourseList()
        }

    }
}
</script>

<style lang="scss" scoped>
.main-box {
    background: #E5F3F1;

    position: relative;

    .head-box {
        width: 100%;
        height: 220px;
        position: relative;

        .head-box-bg {
            position: absolute;
            width: 100%;
            height: 470px;
            top: -80px;
        }

        .head-box-text1 {
            margin-top: 39px;
            margin-left: 212px;
            font-family: HelloFont WenYiHei;
            font-size: 50px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            color: #FFFFFF;
            position: relative;
            z-index: 30;
        }

        .head-box-text2 {
            margin-top: 3px;
            margin-left: 212px;
            font-family: 思源黑体;
            font-size: 20px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            color: #FFFFFF;
            position: relative;
            z-index: 30;

        }

    }

    .content-box-col {
        margin-top: 40px;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .content-box2 {
        width: 91.4777%;
        height: 736px;

        border-radius: 20px;
        opacity: 1;
        background: #FFFFFF;
        position: relative;
        z-index: 20;

        .content-box2-tips {
            margin-top: 28px;
            margin-left: 55px;


            span {

                font-family: 思源黑体;
                font-size: 40px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

        }

        .content-box-titlebox {
            margin-top: 38px;
            margin-left: 55px;
            align-items: flex-end;
        }

        .content-box-title {
            display: inline-block;
            font-family: Source Han Sans CN;
            font-size: 40px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
            position: relative;
            z-index: 30;
        }

        .content-box-title2 {
            margin-left: 29px;
            font-family: Source Han Sans CN;
            font-size: 30px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .content-box-bottom {
            margin-left: 40px;
            width: 95.093%;
            height: 655px;
            position: relative;
            border-top: 1px solid transparent;
            box-sizing: border-box;

            .content-box-bottom-bg {
                width: 100%;
                height: 635px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content-box-bottom-badge {
                width: 641px;
                height: 389px;
                position: absolute;
                top: 80px;
                right: 45px;
            }

            .content-box-mainbox {
                margin-top: 93px;
                margin-left: 49px;
            }

            .content-box-main {
                margin-right: 20px;
                width: 274px;
                height: 207px;
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                position: relative;
                z-index: 30;

                img {
                    width: 100px;
                    height: 100px;
                    margin-left: 14px;
                    margin-right: 14px;
                }

                .content-box-main-info {
                    div {
                        &:first-child {

                            font-family: Source Han Sans CN;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 333333 */
                            color: #333333;
                        }

                        &:last-child {
                            margin-top: 12px;

                            font-family: Oswald;
                            font-size: 24px;
                            font-weight: normal;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 灰 */
                            color: #ACBEB0;
                        }

                    }
                }



            }

            .content-box-btnsbox {
                margin-top: 30px;
                margin-left: 49px;
                position: relative;
                z-index: 20;

                div {
                    &:first-child {
                        text-align: center;
                        margin-right: 22px;
                        width: 134px;
                        height: 46px;
                        border-radius: 100px;

                        /* 绿 */
                        background: #0AA26B;

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 46px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 纯白 */
                        color: #FFFFFF;
                    }

                    &:last-child {
                        text-align: center;
                        width: 261px;
                        height: 46px;
                        border-radius: 100px;

                        box-sizing: border-box;
                        /* 绿 */
                        border: 2px solid #0AA26B;

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 46px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }

                }
            }

        }

    }

    .appraise-popup-title {
        width: 100%;
        height: 86px;
        border-radius: 20px 20px 0 0;
        background: #0AA26B;
        box-sizing: border-box;
        padding: 0 35px;

        .appraise-popup-title-name {
            font-family: 思源黑体;
            font-size: 26px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

        img {
            width: 56px;
            height: 56px;
        }
    }

    .start-popup-content {
        background: #fff;
        border-radius: 0 0 20px 20px;
        box-sizing: border-box;
        padding: 0 52px;

        .start-popup-content-text1 {
            margin-left: 173.5px;
            margin-top: 89px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .start-popup-content-timebox {
            margin-top: 30px;
            margin-left: 173.5px;

            span {
                margin-right: 30px;
                font-family: 思源黑体;
                font-size: 22px;
                font-weight: normal;
                line-height: 30px;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

            .content-box2-select {
                width: 195px;
                height: 64px;
                border-radius: 100px;
                opacity: 1;

                // background: #E5F7F1;

                box-sizing: border-box;
                // border: 1px solid rgba(10, 162, 107, 0.2);
            }

        }

        .start-popup-content-tipsbox {
            margin-top: 89px;
            margin-bottom: 75px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 确认开始学员 */
            color: #333333
        }

        .start-popup-content-line {
            margin-top: 30px;
            width: 100%;
            height: 0px;
            opacity: 1;

            border: 1px solid rgba(10, 162, 107, 0.2);
        }

        .start-popup-content-btnsbox {
            margin-top: 31px;
            margin-bottom: 30px;

            div {
                &:first-child {
                    margin-right: 20px;
                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 灰 */
                    background: #ACBEB0;
                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }

                &:last-child {

                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 绿 */
                    background: #0AA26B;

                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }
            }
        }

    }


}

.content-box-form {
    padding: 33px 30px 26px 41px;
    box-sizing: border-box;
    margin-top: 80px;
    margin-left: 49px;
    width: 46.896%;
    position: relative;
    z-index: 20;
    border-radius: 20px;
    opacity: 1;

    /* 纯白 */
    background: #FFFFFF;

    box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);

    .start-popup-content-btnsbox {

        div {
            &:first-child {
                margin-right: 20px;
                width: 158px;
                height: 46px;
                border-radius: 100px;
                /* 灰 */
                background: #ACBEB0;
                font-family: 思源黑体;
                font-size: 28px;
                font-weight: bold;
                line-height: 46px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;
            }

            &:last-child {
                width: 158px;
                height: 46px;
                border-radius: 100px;
                /* 绿 */
                background: #0AA26B;

                font-family: 思源黑体;
                font-size: 28px;
                font-weight: bold;
                line-height: 46px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;
            }
        }
    }
}


/deep/ .el-textarea__inner {

    font-family: 思源黑体;
    font-size: 18px;
    font-weight: normal;
    line-height: normal;
    display: flex;
    align-items: center;
    letter-spacing: 0em;

    /* 灰 */
    color: #ACBEB0;
}



/deep/ .el-input__inner {
    border: 0;
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;

    /* 333333 */
    color: #333333;
    width: 209px;
    height: 46px;
    border-radius: 100px;
    opacity: 1;

    background: #E5F7F1;

    box-sizing: border-box;
    border: 1px solid rgba(10, 162, 107, 0.2);
}


/deep/ .el-textarea__inner {

    height: 163px;
    border-radius: 20px;
    opacity: 1;
    padding: 13px 19px;
    background: #E5F7F1;

    box-sizing: border-box;
    border: 1px solid rgba(10, 162, 107, 0.2);

}

/deep/ .el-form-item__label {
    font-family: 思源黑体;
    font-size: 22px;
    font-weight: normal;
    line-height: 30px;
    letter-spacing: 0em;

    font-feature-settings: "kern" on;
    /* 333333 */
    color: #333333;
    text-align: left;
    padding-right: 27px;
}


/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>